export default "__VITE_ASSET__BQArnQe2__"